<template lang="pug">
	.dashboard(v-bind:class="{ 'animate-dashboard': lastPartAnimation, 'user-company': selectedCampaign.kind == 'copy' || selectedCampaign.kind == 'contract', 'campaign-finish': campaignFinish }")
		.client-and-campaing-info
			.client
				span Client: 
				p {{ selectedCampaign.campaignClient }}

			.campaign
				span Campaign: 
				p {{ selectedCampaign.name }}

		.cn-transform(ref="get-width")
			.transformation(ref="transform")
				.logo-and-cards
					.campaign-info(v-if="dataLoad")
						.first-card
							.date-card
								span.card-title End Date:
								//- p(v-if="selectedCampaign.kind == 'standard'") {{ moment(campaignData.end_date).format('MMMM')}} {{ moment(campaignData.end_date).format('D') }}
								//- 	span , 
								//- 	| {{ moment(campaignData.end_date).format('YYYY') }}
								p(v-if="campaignData.end_date") {{ moment(campaignData.end_date).format('MMMM')}} {{ moment(campaignData.end_date).format('D') }}
									span , 
									| {{ moment(campaignData.end_date).format('YYYY') }}

								p(v-else) --
									span /
									| --
									span /
									| ----

						.second-card
							.leads-stat
								.til
									p Leads Delivered / Lead Goal

								.from-to(v-if="selectedCampaign.kind == 'standard'")
									//- p {{ total_main.remaining_leads }}
									p {{ total_main.leads_generated }}
									p.blue.slash / 
									p.blue {{ total_main.leads_goal }}

								.from-to(v-else)
									p 0
									p.blue.slash / 
									p.blue 0

						.third-card
							.leads-stat
								.til
									p Leads Generated:

								.from-to(v-if="selectedCampaign.kind == 'standard'")
									p(v-if="campaignData.total_goal != 0 ") {{  Number(total_main.percent_completion).toFixed(0) }}%
									p(v-else) 0%

								.from-to(v-else)
									p 0%

						.four-card
							.user-manager(v-on:click="contactManager()", v-bind:class="{active: RightSidebar.contactM}")
								.photo(v-if="campaignData.managed_by.photo_url")
									img(
										:src="campaignData.managed_by.photo_url",
										alt=""
									)

								.photo.no-photo(v-else)

								.desc
									.by
										p Managed by

									.name
										p {{ campaignData.managed_by.name }}

					.main-logo(
						v-bind:class="{'anim-logo': logoAnim}"
					)

						img(src="@/assets/logo-dashboard.svg", alt="")
				
				.user-campaign
					h4 Your campaign is being launched...

				.hours-block
					.typ-text
						h3 THANK YOU!
						h5 Your campaign has been completed
					.all-statistic(v-if="dataLoad && selectedCampaign.kind == 'standard'")
						.database(v-if="!campaignFinish")
							.left-side
								p.lt Current DataBase
								p.lb INFUSE

							.right-side
								p.rt 252+ million

						.target(v-if="!campaignFinish")
							.left-side
								a(href="./audience", target="_blank").lt(v-on:click="createTASector()") Targeted contacts
								p.lb
									span(v-if="RightSidebar.state == 'running'") Engagement in Process
									span(v-else) Engagement Paused

							.right-side(v-if="RightSidebar.total_audience")
								//- p.rt 8+ million 
								p.rt(v-if="RightSidebar.total_audience < 999999") {{ RightSidebar.total_audience.toLocaleString('en-US') }}
								p.rt(v-else) {{ RightSidebar.total_audience.toString().substring(0,1) }}+ million
								//- p.rb(v-if="campaignData.engagement_in_process_value") {{ engagement_in.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0}) }}
								p.rb(v-if="campaignData.engagement_in_process_value") {{ ((total_main.leads_generated - originalGenerated) + +campaignData.engagement_in_process_value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0}) }}

						.verified(v-if="!campaignFinish")
							.left-side
								router-link(to="./settings#lets_verify", target="_blank").link-verified Verified
								p.lb In Process of Validation

							.right-side
								p.rt {{ total_main.leads_generated }}
								p.rb {{ inProcess }}

						.lead-goal-c(v-if="!campaignFinish")
							.left-side
								span.lead-goal(v-on:click="showLeadPopup()") Lead Goal
								p.rb {{ total_main.leads_goal }}

						router-link(to="./settings", target="_blank").leads-percent-block
							.leads-percent
								.single.top(v-bind:class="{empty: (targetsHours.top.percent == 'empty')}")
									.candle
										.fill(v-bind:style="{ height: targetsHours.top.percent + '%'}")
									.info
										p.value Top
										.b-line
										p.percent(v-if="targetsHours.top.percent >= 0") {{ targetsHours.top.percent }}%
										p.not(v-else) Not Ordered

								.single.middle(v-bind:class="{empty: (targetsHours.middle.percent == 'empty')}")
									.candle
										.fill(v-bind:style="{ height: targetsHours.middle.percent + '%'}")
									.info
										p.value Middle
										.b-line
										p.percent(v-if="targetsHours.middle.percent >= 0") {{ targetsHours.middle.percent }}%
										p.not(v-else) Not Ordered

								.single.bottom(v-bind:class="{empty: (targetsHours.bottom.percent == 'empty')}")
									.candle
										.fill(v-bind:style="{ height: targetsHours.bottom.percent + '%'}")
									.info
										p.value Bottom
										.b-line
										p.percent(v-if="targetsHours.bottom.percent >= 0") {{ targetsHours.bottom.percent }}%
										p.not(v-else) Not Ordered

					.hours(
						v-bind:class="{'first-step-anim': firstAnim, 'second-step-anim': secondAnim}"
					)
						
						.top-part(v-bind:class="{'animate-top': topAnim, 'pause': RightSidebar.state == 'pause', 'copy': selectedCampaign.kind == 'copy' || selectedCampaign.kind == 'contract'}", class="rain")
							<svg width="354" height="454" viewBox="0 0 354 454" fill="none" xmlns="http://www.w3.org/2000/svg">
								<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="354" height="454">
								<path d="M311.964 320.27C350.363 356.615 353.861 400.905 353.861 453.998H0.133301C0.133301 400.902 3.63112 356.615 41.9681 320.27C80.3723 283.926 111.467 271.257 127.14 258.104C142.876 244.952 146.373 234.968 146.373 227.237C146.373 219.454 142.876 209.467 127.14 196.314C111.467 183.162 80.3723 170.493 41.9681 134.149C3.63112 97.8567 0.133301 53.5138 0.133301 0.417969H353.866C353.866 53.5106 350.368 97.8535 311.968 134.146C273.631 170.49 242.532 183.159 226.796 196.311C211.123 209.463 207.625 219.451 207.625 227.234C207.625 234.965 211.123 244.949 226.796 258.101C235.352 265.241 248.402 272.22 264.698 282.956C278.434 291.98 294.421 303.682 311.964 320.27Z" fill="#C4C4C4"/>
								</mask>
								<g mask="url(#mask0)">
									<g class="line-1">
										<rect x="-1.97046" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="13.6873" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="29.343" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="45.0022" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="60.6584" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="76.3176" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="91.9734" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="107.631" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="123.288" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="138.946" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="154.604" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="170.26" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="185.917" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="201.574" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="217.234" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="232.89" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="248.548" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="264.205" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="279.863" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="295.52" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="311.176" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="326.835" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="342.491" y="63.7949" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
									</g>
									<g class="line-2" ref="rain-1">
										<rect x="-1.97046" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="13.6873" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="29.343" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="45.0022" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="60.6584" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="76.3176" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="91.9734" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="107.631" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="123.288" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="138.946" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="154.604" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="170.26" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="185.917" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="201.574" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="217.234" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="232.89" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="248.548" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="264.205" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="279.863" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="295.52" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="311.176" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="326.835" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
										<rect x="342.491" y="79.4403" width="14.3814" height="14.3701" rx="3" fill="#10A0CD"/>
									</g>
									<g class="line-3" ref="ta-t" v-bind:class="{'fill-line': (workingLines >= 3 || workingLines == 1 && baseFill >= 7 || workingLines == 2 && baseFill >= 4)}">
										<rect />
										<rect x="13.6873" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 3 && baseFill >= 4) }"/>
										<rect x="29.343" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 2 && baseFill >= 7 || workingLines == 3 && baseFill >= 3) }"/>
										<rect x="45.0022" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 2 && baseFill >= 6 || workingLines == 3 && baseFill >= 2) }"/>
										<rect x="60.6584" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 2 && baseFill >= 5 || workingLines == 3 && baseFill >= 1) }"/>

										<rect x="76.3176" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -1)}"/>
										<rect x="91.9734" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -2)}"/>
										<rect x="107.631" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="123.288" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}""/>
										<rect x="138.946" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="154.604" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="170.26" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="185.917" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="201.574" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="217.234" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="232.89" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -3)}"/>
										<rect x="248.548" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -2)}"/>
										<rect x="264.205" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -1)}"/>

										<rect x="279.863" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 2 && baseFill >= 5 || workingLines == 3 && baseFill >= 1) }"/>
										<rect x="295.52" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 2 && baseFill >= 6 || workingLines == 3 && baseFill >= 2) }"/>
										<rect x="311.176" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 2 && baseFill >= 7 || workingLines == 3 && baseFill >= 3) }"/>
										<rect x="326.835" y="95.0853" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 3 && baseFill >= 4) }"/>
									</g>
									<g class="line-4" ref="ta-m" v-bind:class="{'fill-line': (workingLines >= 2 || workingLines == 1 && baseFill >= 3)}">
										<rect />
										<rect x="13.6873" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 7 || workingLines == 2 && baseFill >= 4 || workingLines == 3 && baseFill >= 4) }"/>
										<rect x="29.343" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 6 || workingLines == 2 && baseFill >= 3 || workingLines == 3 && baseFill >= 3) }"/>
										<rect x="45.0022" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 5 || workingLines == 2 && baseFill >= 2 || workingLines == 3 && baseFill >= 2) }"/>
										<rect x="60.6584" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 4 || workingLines == 2 && baseFill >= 1 || workingLines == 3 && baseFill >= 1) }"/>

										<rect x="76.3176" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -4 || workingLines == 2 && baseFill > -1)}"/>
										<rect x="91.9734" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -5 || workingLines == 2 && baseFill > -2)}"/>
										<rect x="107.631" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -3)}"/>
										<rect x="123.288" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -4)}"/>
										<rect x="138.946" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -4)}"/>
										<rect x="154.604" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -4)}"/>
										<rect x="170.26" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -4)}"/>
										<rect x="185.917" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -4)}"/>
										<rect x="201.574" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -4)}"/>
										<rect x="217.234" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -4)}"/>
										<rect x="232.89" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -6 || workingLines == 2 && baseFill > -3)}"/>
										<rect x="248.548" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -5 || workingLines == 2 && baseFill > -2)}"/>
										<rect x="264.205" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -4 || workingLines == 2 && baseFill > -1)}"/>

										<rect x="279.863" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 4 || workingLines == 2 && baseFill >= 1 || workingLines == 3 && baseFill >= 1) }"/>
										<rect x="295.52" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 5 || workingLines == 2 && baseFill >= 2 || workingLines == 3 && baseFill >= 2) }"/>
										<rect x="311.176" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 6 || workingLines == 2 && baseFill >= 3 || workingLines == 3 && baseFill >= 3) }"/>
										<rect x="326.835" y="110.731" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 7 || workingLines == 2 && baseFill >= 4 || workingLines == 3 && baseFill >= 4) }"/>
									</g>
									<g class="line-5" ref="ta-b" v-bind:class="{'fill-line': (workingLines >= 1)}">
										<rect />
										<rect />
										<rect x="29.343" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 3 || workingLines == 2 && baseFill >= 3 || workingLines == 3 && baseFill >= 3) }"/>
										<rect x="45.0022" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 2 || workingLines == 2 && baseFill >= 2 || workingLines == 3 && baseFill >= 2) }"/>
										<rect x="60.6584" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 1 || workingLines == 2 && baseFill >= 1 || workingLines == 3 && baseFill >= 1) }"/>

										<rect x="76.3176" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -7 || workingLines == 2 && baseFill > -5 || workingLines == 1 && baseFill > -1)}"/>
										<rect x="91.9734" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -6 || workingLines == 1 && baseFill > -2)}"/>
										<rect x="107.631" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -3)}"/>

										<rect x="123.288" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -4)}"/>
										<rect x="138.946" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -4)}"/>
										<rect x="154.604" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -4)}"/>
										<rect x="170.26" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -4)}"/>
										<rect x="185.917" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -4)}"/>
										<rect x="201.574" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -4)}"/>
										<rect x="217.234" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -4)}"/>

										<rect x="232.89" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -7 || workingLines == 1 && baseFill > -3)}"/>
										<rect x="248.548" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 || workingLines == 2 && baseFill > -6 || workingLines == 1 && baseFill > -2)}"/>
										<rect x="264.205" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (baseFill >= 0 || workingLines == 3 && baseFill > -7 || workingLines == 2 && baseFill > -5 || workingLines == 1 && baseFill > -1)}"/>

										<rect x="279.863" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 1 || workingLines == 2 && baseFill >= 1 || workingLines == 3 && baseFill >= 1) }"/>
										<rect x="295.52" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 2 || workingLines == 2 && baseFill >= 2 || workingLines == 3 && baseFill >= 2) }"/>
										<rect x="311.176" y="126.376" width="14.3814" height="14.3701" rx="3" v-bind:class="{fill: (workingLines == 1 && baseFill >= 3 || workingLines == 2 && baseFill >= 3 || workingLines == 3 && baseFill >= 3) }"/>
									</g>
									<g class="line-6" ref="rain-2">
										<rect x="-1.97046" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="60.6584" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="76.3176" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="91.9734" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="107.631" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="123.288" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="138.946" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="154.604" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="170.26" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="185.917" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="201.574" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="217.234" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="232.89" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="248.548" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="264.205" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="279.863" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="295.52" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="311.176" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="142.021" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="line-7" ref="rain-3">
										<rect x="-1.97046" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="76.3176" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="91.9734" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="107.631" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="123.288" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="138.946" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="154.604" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="170.26" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="185.917" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="201.574" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="217.234" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="232.89" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="248.548" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="264.205" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="279.863" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="295.52" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="157.666" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="line-8" ref="rain-4">
										<rect x="-1.97046" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="107.631" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="123.288" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="138.946" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="154.604" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="170.26" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="185.917" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="201.574" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="217.234" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="232.89" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="248.548" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="264.205" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="173.311" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="line-9" ref="rain-5">
										<rect x="-1.97046" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="123.288" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="138.946" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="154.604" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="170.26" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="185.917" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="201.574" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="217.234" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="232.89" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="248.548" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="188.957" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="line-10" ref="rain-6">
										<rect x="-1.97046" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="138.946" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="154.604" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="170.26" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="185.917" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="201.574" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="217.234" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="232.89" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="204.602" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="line-11" ref="rain-7">
										<rect x="-1.97046" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="13.6873" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="29.343" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="45.0022" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="60.6584" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="76.3176" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="91.9734" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="107.631" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="123.288" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="138.946" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="154.604" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="170.26" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="185.917" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="201.574" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="217.234" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="232.89" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="248.548" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="264.205" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="279.863" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="295.52" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="311.176" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="326.835" y="220.246" width="14.3814" height="14.3701" rx="3"/>
										<rect x="342.491" y="220.246" width="14.3814" height="14.3701" rx="3"/>
									</g>
								</g>
							</svg>

						.bottom-part(v-bind:class="{'animate-bottom': bottomAnim, 'animate-reverse': reverseAnimation, 'hide-squares': hideSquares && selectedCampaign.kind == 'standard', 'pause': RightSidebar.state == 'pause'}"
						ref="bottom-part")
							<svg width="354" height="454" viewBox="0 0 354 454" fill="none" xmlns="http://www.w3.org/2000/svg">
								<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="354" height="454">
								<path d="M311.964 320.27C350.363 356.615 353.861 400.905 353.861 453.998H0.133301C0.133301 400.902 3.63112 356.615 41.9681 320.27C80.3723 283.926 111.467 271.257 127.14 258.104C142.876 244.952 146.373 234.968 146.373 227.237C146.373 219.454 142.876 209.467 127.14 196.314C111.467 183.162 80.3723 170.493 41.9681 134.149C3.63112 97.8567 0.133301 53.5138 0.133301 0.417969H353.866C353.866 53.5106 350.368 97.8535 311.968 134.146C273.631 170.49 242.532 183.159 226.796 196.311C211.123 209.463 207.625 219.451 207.625 227.234C207.625 234.965 211.123 244.949 226.796 258.101C235.352 265.241 248.402 272.22 264.698 282.956C278.434 291.98 294.421 303.682 311.964 320.27Z" fill="#C4C4C4"/>
								</mask>
								<g class="secret-square" v-if="dataLoad" v-on:click="selectUnselect()">
									<rect x="60.6584" y="142.021" width="14.3814" height="14.3701" rx="3" fill="transparent"></rect>
								</g>
								<g mask="url(#mask0)">
									<g class="working-line line-1" ref="hide-on-load">
										<rect x="-1.97046" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="138.946" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="154.604" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="170.26" y="220.246" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="185.917" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="201.574" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#24F2FF"/>
										<rect x="217.234" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="232.89" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="220.246" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-2">
										<rect x="-1.97046" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="138.946" y="235.893" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="154.604" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="235.893" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="217.234" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="232.89" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="235.893" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-3">
										<rect x="-1.97046" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="138.946" y="251.537" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="154.604" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="251.537" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="217.234" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="232.89" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="251.537" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-4">
										<rect x="-1.97046" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="138.946" y="267.183" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="154.604" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="267.183" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="217.234" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="232.89" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="267.183" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-5">
										<rect x="-1.97046" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="138.946" y="282.828" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="154.604" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="282.828" width="14.3814" height="14.3701" rx="3" class="fill-on-select"/>
										<rect x="217.234" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="232.89" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="282.828" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-6">
										<rect x="-1.97046" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="138.946" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="154.604" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="217.234" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="232.89" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="298.473" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-7">
										<rect x="-1.97046" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="107.631" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="123.288" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="138.946" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="154.604" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="217.234" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="232.89" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="248.548" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="264.205" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="314.118" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-8">
										<rect x="-1.97046" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="329.763" width="14.3814" height="14.3701" rx="3"/>
										<rect x="107.631" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="123.288" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="138.946" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="154.604" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="217.234" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="232.89" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="248.548" y="329.763" width="14.3814" height="14.3701" rx="3"/>
										<rect x="264.205" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="329.763" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-9">
										<rect x="-1.97046" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="13.6873" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="29.343" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="45.0022" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="60.6584" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="76.3176" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="91.9734" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="107.631" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="123.288" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="138.946" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="154.604" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="170.26" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="185.917" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="201.574" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="217.234" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="232.89" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="248.548" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#86F000"/>
										<rect x="264.205" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="279.863" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="295.52" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="311.176" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="326.835" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
										<rect x="342.491" y="345.408" width="14.3814" height="14.3701" rx="3" fill="#064366"/>
									</g>
									<g class="working-line line-10 line-t" ref="line-1">
										<rect></rect>
										<rect></rect>
										<rect></rect>
										<rect></rect>
										<rect x="61.6584" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="77.3176" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="92.9734" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="108.631" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="124.288" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="139.946" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="155.604" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="171.26" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="186.917" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="202.574" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="218.234" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="233.89" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="249.548" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="265.205" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
										<rect x="280.863" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>
									</g>
									<g class="working-line line-11 line-t" ref="line-2">
										<rect></rect>
										<rect></rect>
										<rect></rect>
										<rect></rect>
										<rect x="61.6584" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="77.3176" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="92.9734" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="108.631" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="124.288" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="139.946" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="155.604" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="171.26" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="186.917" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="202.574" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="218.234" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="233.89" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="249.548" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="265.205" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="280.863" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>
									</g>
									<g class="working-line line-12 line-m" ref="line-3">
										<rect x="-0.97046" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="14.6873" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="30.343" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="46.0022" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="61.6584" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="77.3176" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="92.9734" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="108.631" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="124.288" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="139.946" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="155.604" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="171.26" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="186.917" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="202.574" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="218.234" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="233.89" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="249.548" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="265.205" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="280.863" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="296.52" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="312.176" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="327.835" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="343.491" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>
									</g>
									<g class="working-line line-13 line-m" ref="line-fill-one">
										<rect x="-0.97046" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="14.6873" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="30.343" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="46.0022" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="61.6584" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="77.3176" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="92.9734" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="108.631" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="124.288" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="139.946" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="155.604" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="171.26" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="186.917" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="202.574" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="218.234" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="233.89" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="249.548" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="265.205" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="280.863" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="296.52" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="312.176" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="327.835" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="343.491" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>
									</g>
									<g class="working-line line-14 line-b" ref="line-fill-two">
										<rect x="-0.97046" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="14.6873" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="30.343" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="46.0022" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="61.6584" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="77.3176" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="92.9734" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="108.631" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="124.288" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="139.946" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="155.604" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="171.26" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="186.917" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="202.574" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="218.234" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="233.89" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="249.548" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="265.205" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="280.863" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="296.52" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="312.176" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="327.835" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="343.491" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>
									</g>
									<g class="working-line line-15 line-b" ref="line-fill-three">
										<rect x="-0.97046" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="14.6873" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="30.343" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="46.0022" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="61.6584" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="77.3176" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="92.9734" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="108.631" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="124.288" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="139.946" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="155.604" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="171.26" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="186.917" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="202.574" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="218.234" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="233.89" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="249.548" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="265.205" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="280.863" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="296.52" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="312.176" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="327.835" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
										<rect x="343.491" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>
									</g>
								</g>
								</svg>

						.integrated(v-if="dataLoad && selectedCampaign.kind == 'standard' && !this.campaignFinish")
							p(v-on:click="showIntegratePopup()") Integrated with: 
								span {{ campaignData.integration_type.name }}

				.popup-bg(
					v-if="showIntegrate || showGoal"
					v-on:click="hidePopups()"
				)

				.for-popup(v-if="showIntegrate")
					.integrate-popup
						.close(v-on:click="hidePopups()")
						h4 Integrated with:
						.select-list
							.single-item
								input(type="radio", name="integrate-with", v-model="integrationType.Salesforce", value="Salesforce").ch#ch-salesforce
								label(for="ch-salesforce").check-container
									.name
										h6 Salesforce

										.ico

									.logo-i
										.salesforce

							.single-item
								input(type="radio", name="integrate-with", v-model="integrationType.Marketo", value="Marketo").ch#ch-marketo
								label(for="ch-marketo").check-container
									.name
										h6 Marketo

										.ico

									.logo-i
										.marketo

							.single-item
								input(type="radio", name="integrate-with", v-model="integrationType.HubSpot", value="HubSpot").ch#ch-hubspot
								label(for="ch-hubspot").check-container
									.name
										h6 HubSpot

										.ico

									.logo-i
										.hubspot

							.single-item
								input(type="radio", name="integrate-with", v-model="integrationType.Lolagrove", value="Lolagrove").ch#ch-lolagrove
								label(for="ch-lolagrove").check-container
									.name
										h6 Lolagrove

										.ico

									.logo-i
										.lolagrove

							.single-item.custom-item
								input(type="radio", name="integrate-with", v-model="integrationType.custom_integration", value="custom_integration").ch#ch-custom
								label(for="ch-custom").check-container
									.name
										h6 Custom 
											br
											| Integration

										.ico

									.logo-i
										p {{ campaignData.integration_type.name }}
										.custom

							router-link(to="./settings", target="_blank").for-btn
								button.btn.arrow(type="button")

				.for-popup(v-if="showGoal")
					.lead-goal-popup
						.close(v-on:click="hidePopups()")
						h4 Lead Goal

						.goals-list
							.single(v-for="item in campaignData.targets")
								p
									marquee(behavior="scroll" direction="left") {{ item.type_name }}
								h5(v-bind:class="item.grade") {{ item.leads_goal }} 
									span Leads

							.single
								p Pacing:
								h5.pacing.yellow {{ campaignData.pacing_type.name }}

						router-link(to="./settings", target="_blank").btn.edit-goal(type="button") edit goals

</template>
<!-- rows [4, 7, 9, 11, 14, 15, 17, 20] -->
<!-- line [1, 3, 4, 0, 7, 6, 5, 2] -->
<script>
	import IntegratePopup from '@/components/Integrate-Popup'
	import LeadGoal from '@/components/Lead-Goal'
	import moment from 'moment'

	import { mapMutations, mapGetters } from 'vuex'

	export default {
		name: 'HourGlass',
		components: {
			IntegratePopup,
			LeadGoal
		},
		data(){
			return {
				hourMatrix: [],
				fullSpeed: 10000,
				logoAnim: false,
				firstAnim: false,
				secondAnim: false,
				topAnim: false,
				bottomAnim: false,
				animationFinished: false,
				selectedCampaign: Object,
				campaignData: Object,
				dataLoad: false,
				reverseAnimation: false,
				lastPartAnimation: false,
				hideSquares: false,
				integrateWith: false,
				integrationType: {
					Salesforce: false,
					Marketo: false,
					HubSpot: false,
					Lolagrove: false,
					custom_integration: false
				},
				showIntegrate: false,
				showGoal: false,
				emptyTop: true,
				emptyMiddle: true,
				emptyBottom: true,
				total_main: [Array, Object],
				inProcess: null,
				baseFill: 0,
				workingLines: 3,
				squares: [
					'<rect x="265.205" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="249.548" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="233.89" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="218.234" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="202.574" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="186.917" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="171.26" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="155.604" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="139.946" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="124.288" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="108.631" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="92.9734" y="362.053" width="12.3814" height="12.3701" rx="3"></rect><rect x="77.3176" y="362.053" width="12.3814" height="12.3701" rx="3"></rect>',
					'<rect x="280.863" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="265.205" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="249.548" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="233.89" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="218.234" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="202.574" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="186.917" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="171.26" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="155.604" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="139.946" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="124.288" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="108.631" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="92.9734" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="77.3176" y="377.699" width="12.3814" height="12.3701" rx="3"/><rect x="61.6584" y="377.699" width="12.3814" height="12.3701" rx="3"/>',
					'<rect x="296.52" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="280.863" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="265.205" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="249.548" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="233.89" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="218.234" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="202.574" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="186.917" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="171.26" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="155.604" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="139.946" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="124.288" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="108.631" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="92.9734" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="77.3176" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="61.6584" y="393.344" width="12.3814" height="12.3701" rx="3"/><rect x="46.0022" y="393.344" width="12.3814" height="12.3701" rx="3"/>',
					'<rect x="312.176" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="296.52" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="280.863" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="265.205" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="249.548" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="233.89" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="218.234" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="202.574" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="186.917" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="171.26" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="155.604" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="139.946" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="124.288" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="108.631" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="92.9734" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="77.3176" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="61.6584" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="46.0022" y="408.989" width="12.3814" height="12.3701" rx="3"/><rect x="30.343" y="408.989" width="12.3814" height="12.3701" rx="3"/>',
					'<rect x="327.835" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="312.176" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="296.52" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="280.863" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="265.205" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="249.548" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="233.89" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="218.234" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="202.574" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="186.917" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="171.26" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="155.604" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="139.946" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="124.288" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="108.631" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="92.9734" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="77.3176" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="61.6584" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="46.0022" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="30.343" y="424.634" width="12.3814" height="12.3701" rx="3"/><rect x="14.6873" y="424.634" width="12.3814" height="12.3701" rx="3"/>',
					'<rect x="343.491" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="327.835" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="312.176" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="296.52" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="280.863" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="265.205" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="249.548" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="233.89" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="218.234" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="202.574" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="186.917" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="171.26" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="155.604" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="139.946" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="124.288" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="108.631" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="92.9734" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="77.3176" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="61.6584" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="46.0022" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="30.343" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="14.6873" y="440.28" width="12.3814" height="12.3701" rx="3"/><rect x="-0.97046" y="440.28" width="12.3814" height="12.3701" rx="3"/>'
				],
				defaultBottom:{
					top: ['<rect x="61.6584" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="77.3176" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="92.9734" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="108.631" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="124.288" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="139.946" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="155.604" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="171.26" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="186.917" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="202.574" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="218.234" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="233.89" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="249.548" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="265.205" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="280.863" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect>', '<rect x="61.6584" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>'],
					middle: ['<rect x="-0.97046" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>', '<rect x="-0.97046" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>'],
					bottom: ['<rect x="-0.97046" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>', '<rect x="-0.97046" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>']
				},
				targetsHours: {
					top: {
						leads_goal: 0,
						leads_generated: 0,
						percent: false
					},
					middle: {
						leads_goal: 0,
						leads_generated: 0,
						percent: false
					},
					bottom: {
						leads_goal: 0,
						leads_generated: 0,
						percent: false
					}
				},
				TAS: {
					ABM: {
						delta: 0,
						defaultStatus: null
					},
					SuppressionList: {
						delta: 0,
						defaultStatus: null
					},
					JobTitle: {
						delta: 0,
						defaultStatus: null
					},
					Industries: {
						delta: 0,
						defaultStatus: null
					},
					Geo: {
						delta: 0,
						defaultStatus: null
					},
					Revenue: {
						delta: 0,
						defaultStatus: null
					},
					CompanySize: {
						delta: 0,
						defaultStatus: null
					},
					ITCurated: 0
				},
				workingStrings: 0,
				new_velocity: 0,
				engagement_in: 0,
				originalGenerated: 0,
				finish:{
					top: false,
					middle: false,
					bottom: false
				},
				campaignFinish: false,
				finishBottom:{
					top: ['<rect x="-0.97046" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="77.3176" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="92.9734" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="108.631" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="124.288" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="139.946" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="155.604" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="171.26" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="186.917" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="202.574" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="218.234" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="233.89" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="249.548" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="265.205" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="280.863" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="296.52" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="330.761" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="-0.97046" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="77.3176" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="92.9734" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="108.631" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="124.288" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="139.946" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="155.604" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="171.26" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="186.917" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="202.574" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="218.234" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="233.89" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="249.548" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="265.205" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="280.863" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="296.52" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="346.407" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="-0.97046" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="77.3176" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="92.9734" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="108.631" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="124.288" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="139.946" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="155.604" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="171.26" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="186.917" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="202.574" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="218.234" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="233.89" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="249.548" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="265.205" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="280.863" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"></rect><rect x="296.52" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="362.053" width="12.3814" height="12.3701" rx="3" class="fill"/>', '<rect x="-0.97046" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="377.699" width="12.3814" height="12.3701" rx="3" class="fill"/>'],
					middle: ['<rect x="-0.97046" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="393.344" width="12.3814" height="12.3701" rx="3" class="fill"/>', '<rect x="-0.97046" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="408.989" width="12.3814" height="12.3701" rx="3" class="fill"/>'],
					bottom: ['<rect x="-0.97046" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="424.634" width="12.3814" height="12.3701" rx="3" class="fill"/>', '<rect x="-0.97046" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="14.6873" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="30.343" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="46.0022" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="61.6584" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="77.3176" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="92.9734" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="108.631" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="124.288" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="139.946" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="155.604" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="171.26" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="186.917" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="202.574" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="218.234" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="233.89" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="249.548" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="265.205" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="280.863" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="296.52" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="312.176" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="327.835" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/><rect x="343.491" y="440.28" width="12.3814" height="12.3701" rx="3" class="fill"/>']
				}
				// delivered: 0
			}
		},
		created: function(){
			// this.runHour();
			// window.SelectC.init();
			this.moment = moment;
			setTimeout(() => this.startFirstAnim(), 1000)
		},
		computed: {
			...mapGetters(['RightSidebar']),
			SC(){
				return this.$store.getters.SC.id;
			}
		},
		watch: {
			SC(){
				this.resetData();
				// this.RS = this.$store.state.SC
				this.finish = {
					top: false,
					middle: false,
					bottom: false
				};
				this.campaignFinish = false;
				this.campaignData = Object;
				this.targetsHours = {
					top: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					},
					middle: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					},
					bottom: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					}
				};
				this.selectedCampaign = this.$store.state.SelectedCampaign;
				this.loadCampaignData();
			},
			'RightSidebar.trigger': function () {
				this.changeTA();
			}
			// SelectedCampaign(){
			// 	this.selectedCampaign = this.$store.state.SelectedCampaign;
			// }
		},
		methods:{
			...mapMutations(['setRS', 'updateRS']),
			resetData(){
				this.targetsHours = {
					top: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					},
					middle: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					},
					bottom: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					}
				};
				this.TAS = {
					ABM: {
						delta: 0,
						defaultStatus: null
					},
					SuppressionList: {
						delta: 0,
						defaultStatus: null
					},
					JobTitle: {
						delta: 0,
						defaultStatus: null
					},
					Industries: {
						delta: 0,
						defaultStatus: null
					},
					Geo: {
						delta: 0,
						defaultStatus: null
					},
					Revenue: {
						delta: 0,
						defaultStatus: null
					},
					CompanySize: {
						delta: 0,
						defaultStatus: null
					},
					ITCurated: 0
				};
				this.workingStrings = 0;
				this.new_velocity = 0;
				this.engagement_in = 0;
				this.originalGenerated = 0;
			},
			resetAnim(){
				// this.firstAnim = false
				// this.secondAnim = false
				// this.logoAnim = false
				// this.topAnim = false
				// this.bottomAnim = false
				// setTimeout(() => this.startFirstAnim(), 3000)
				this.lastPartAnimation = false;
				setTimeout(() => {
					this.lastPartAnimation = true;
				}, 3000);
			},
			sortTarget: function (obj){
				return obj.sort((a, b) => b.grade.localeCompare(a.grade));
			},
			startFirstAnim(){
				// var originalWidth = this.$refs.['get-width'].clientHeight;
				// this.$refs.['transform'].style.cssText = 'transform: scale('+originalWidth/660+'); height: 660px;';
				this.logoAnim = true;
				this.firstAnim = true;
				setTimeout(() => this.secondAnim = true, 1000)
				setTimeout(() => {
					this.topAnim = true;
					this.bottomAnim = true
				} , 2000);
				setTimeout(() => {
					this.animationFinished = true;
					this.loadCampaignData()
				}, 4000);
			},
			calculateLeads(){
				this.reverseAnimation = true;
				this.hideSquares = true;
				setTimeout(() => {
					this.lastPartAnimation = true;
					if (this.campaignData.kind == 'standard') {
						this.createHours();
					}
				}, 500);
				setTimeout(() => {
					this.reverseAnimation = false;
					if (this.campaignData.kind == 'standard' && !this.campaignFinish) {
						this.checkProgress();
					}
				}, 1100);
				setInterval(() => {
					if (this.campaignData.kind == 'standard' && !this.campaignFinish) {
						this.checkProgress();
						this.generateLeads();
					}
				}, 3600000)
				// }, 60000)
			},
			loadCampaignData(){
				if (this.animationFinished && this.selectedCampaign.id) {
					var id = this.selectedCampaign.id;
					window.api.get('campaign/'+id+'/hourglass')
						.then(campaign => {
							this.campaignData = campaign.data;
							this.calculateLeads();
							this.logoAnim = false;
							this.dataLoad = true;
							this.calcOriginal();
							this.calcTotal();
							this.sortTarget(this.campaignData.targets);
							var st = {
								sections: campaign.data.sections,
								tactics: campaign.data.tactics,
								state: campaign.data.state,
								sectionsLoad: true,
								manager: campaign.data.managed_by
							}
							this.setRS(st);
							this.createTASector();
							if (campaign.data.integration_type) {
								this.integrateWith = campaign.data.integration_type.name;
							}
							this.integrated();
							this.engagement_in = +campaign.data.engagement_in_process_value + (campaign.data.base_velocity * 2);
							setTimeout(() => {this.rainAnimation()}, 500)
							if (campaign.data.kind == 'copy' || campaign.data.kind == 'contract') {
								this.setDefaultHours();
							}
						})
						.catch(campaignError => {
							console.log(campaignError);
						})
						localStorage.removeItem('campaign_from_settings');
				}else{
					this.selectedCampaign = this.$store.state.SelectedCampaign;
					this.loadCampaignData();
				}
			},
			integrated(){
				this.integrationType = {
					Salesforce: false,
					Marketo: false,
					HubSpot: false,
					Lolagrove: false,
					custom_integration: false
				}
				var index = Object.keys(this.integrationType).find(key => key === this.integrateWith);
				if (index) {
					this.integrationType[index] = this.integrateWith;
				}else{
					this.integrationType['custom_integration'] = 'custom_integration';
				}
			},
			changeTA(){
				var baseAudience = this.campaignData.audience_targeted;
				var zero = 0;
				// this.baseFill = Number(this.campaignData.ta_volume).toFixed(0);
				this.baseFill = 0;

				for (var single in this.RightSidebar.sections) {
					var sectorDelta = 0;

					if(this.TAS[this.RightSidebar.sections[single].slug]){
						sectorDelta = this.TAS[this.RightSidebar.sections[single].slug].delta;

						if (!this.RightSidebar.sections[single].enabled) {
							if (this.TAS[this.RightSidebar.sections[single].slug].defaultStatus != this.RightSidebar.sections[single].enabled) {
								if (sectorDelta > 0) {
									baseAudience = baseAudience - Math.abs(sectorDelta);
									this.baseFill = this.baseFill - 1;
								}else{
									baseAudience = baseAudience + Math.abs(sectorDelta);
									this.baseFill = this.baseFill + 1;
								}
							}
						}else{
							if (this.TAS[this.RightSidebar.sections[single].slug].defaultStatus != this.RightSidebar.sections[single].enabled) {
								if (sectorDelta > 0) {
									baseAudience = baseAudience + Math.abs(sectorDelta);
									this.baseFill = this.baseFill + 1;
								}else{
									baseAudience = baseAudience - Math.abs(sectorDelta);
									this.baseFill = this.baseFill - 1;
								}
							}
						}
					}
				}

				var velocity = this.campaignData.base_velocity;

				for (var item in this.RightSidebar.sections) {
					if (this.RightSidebar.sections[item].enabled) {
						velocity += this.RightSidebar.sections[item].delta_v_sector;
					}
				}

				this.new_velocity = velocity;
				if (this.new_velocity < 0) {
					this.new_velocity = 0;
				}
				
				this.engagement_in = +this.campaignData.engagement_in_process_value + (velocity * 2)

				zero += baseAudience;

				this.updateRS(['total_audience', zero]);
			},
			createTASector(){

				this.workingLines = this.campaignData.ta_volume;

				this.TAS.ABM = {
					delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'ABM').delta_ta_sector) / 100)).toFixed(0),
					defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'ABM').enabled
				};

				this.TAS.SuppressionList = {
					delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'SuppressionList').delta_ta_sector) / 100)).toFixed(0),
					defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'SuppressionList').enabled
				};

				this.TAS.JobTitle = {
					delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'JobTitle').delta_ta_sector) / 100)).toFixed(0),
					defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'JobTitle').enabled
				};

				this.TAS.Industries = {
					delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'Industries').delta_ta_sector) / 100)).toFixed(0),
					defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'Industries').enabled
				};

				this.TAS.Geo = {
					delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'Geo').delta_ta_sector) / 100)).toFixed(0),
					defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'Geo').enabled
				};

				this.TAS.Revenue = {
					delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'Revenue').delta_ta_sector) / 100)).toFixed(0),
					defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'Revenue').enabled
				};

				this.TAS.CompanySize = {
					delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'CompanySize').delta_ta_sector) / 100)).toFixed(0),
					defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'CompanySize').enabled
				};

				// this.TAS.ITCurated = {
				// 	delta: Number(this.campaignData.audience_targeted * ((this.RightSidebar.sections.find(item => item.slug === 'ITCurated').delta_ta_sector) / 100)).toFixed(0),
				// 	defaultStatus: this.RightSidebar.sections.find(item => item.slug === 'ITCurated').enabled
				// };

				this.updateRS(['TAS', this.TAS]);

				var baseAudience = this.campaignData.audience_targeted;

				this.updateRS(['total_audience', baseAudience]);

				var maxAudience = 0;
				for(var item in this.TAS){
					if ((!this.TAS[item].defaultStatus && this.TAS[item].delta > 0) || (this.TAS[item].defaultStatus && this.TAS[item].delta < 0)) {
							var dl = Math.abs(this.TAS[item].delta)
							maxAudience = +maxAudience + +dl;
					}
				}

				var velocity = this.campaignData.base_velocity;

				for (var single in this.RightSidebar.sections) {
					if (this.RightSidebar.sections[single].enabled) {
						velocity += this.RightSidebar.sections[single].delta_v_sector;
					}
				}

				this.new_velocity = velocity;
				if (this.new_velocity < 0) {
					this.new_velocity = 0;
				}
				this.engagement_in = +this.campaignData.engagement_in_process_value + (velocity * 2)

				this.updateRS(['max_audience', (+maxAudience + +baseAudience)]);
			},
			getSquares(from, to){
				var squaresLines = [];
				for (var s = from; s <= to; s++) {
					squaresLines.push(this.squares[s])
				}
				return squaresLines;
			},
			createHours(){
				this.targetsHours = {
					top: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					},
					middle: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					},
					bottom: {
						leads_goal: 0,
						leads_generated: 0,
						percent: 'empty'
					}
				}

				this.$refs.['line-1'].classList.remove('line-t', 'line-m', 'line-b');
				this.$refs.['line-2'].classList.remove('line-t', 'line-m', 'line-b');
				this.$refs.['line-3'].classList.remove('line-m', 'line-m', 'line-b');

				this.$refs.['line-fill-one'].classList.remove('line-t', 'line-m', 'line-b');
				this.$refs.['line-fill-two'].classList.remove('line-t', 'line-m', 'line-b');
				this.$refs.['line-fill-three'].classList.remove('line-t', 'line-m', 'line-b');

				var top = false;
				var middle = false;
				var bottom = false;

				var stringCount = 0;

				for(var item in this.campaignData.targets){
					if (this.campaignData.targets[item].grade == 'Top') {
						this.targetsHours.top.leads_goal += +Number(this.campaignData.targets[item].leads_goal).toFixed(0);
						this.targetsHours.top.leads_generated += +Number(this.campaignData.targets[item].leads_generated).toFixed(0);
						if (!top) {
							stringCount += 1;
						}
						top = true;
					}
					if (this.campaignData.targets[item].grade == 'Middle') {
						this.targetsHours.middle.leads_goal += +Number(this.campaignData.targets[item].leads_goal).toFixed(0);
						this.targetsHours.middle.leads_generated += +Number(this.campaignData.targets[item].leads_generated).toFixed(0);
						if (!middle) {
							stringCount += 1;
						}
						middle = true;
					}
					if (this.campaignData.targets[item].grade == 'Bottom') {
						this.targetsHours.bottom.leads_goal += +Number(this.campaignData.targets[item].leads_goal).toFixed(0);
						this.targetsHours.bottom.leads_generated += +Number(this.campaignData.targets[item].leads_generated).toFixed(0);
						if (!bottom) {
							stringCount += 1;
						}
						bottom = true;
					}
				}

				for (var single in this.targetsHours) {
					if (this.targetsHours[single].leads_goal != 0) {
						this.targetsHours[single].percent = Math.floor(Number(this.targetsHours[single].leads_generated / this.targetsHours[single].leads_goal * 100).toFixed(3));
					}
				}

				this.workingStrings = this.campaignData.dashboard_string_count;

				this.$refs.['line-1'].innerHTML = '';
				this.$refs.['line-2'].innerHTML = '';
				this.$refs.['line-3'].innerHTML = '';

				this.$refs.['line-fill-one'].innerHTML = '';
				this.$refs.['line-fill-two'].innerHTML = '';
				this.$refs.['line-fill-three'].innerHTML = '';

				var emptyLines = [];

				for(var d = 0; d <= (5 - this.workingStrings); d++){
					emptyLines.push(this.squares[d])
				}

				this.$refs.['line-1'].innerHTML = emptyLines;
				this.$refs.['line-1'].classList.add('empty');

				var from = 6 - Number(this.workingStrings).toFixed(0);
				var to = this.squares.length - 1;

				if (stringCount == 3) {

					this.$refs.['line-fill-one'].classList.add('line-t', 'animate');
					this.$refs.['line-fill-two'].classList.add('line-m', 'animate');
					this.$refs.['line-fill-three'].classList.add('line-b', 'animate');

					// top 500
					// middle 600
					// bottom 600

					if (this.targetsHours.top.leads_goal > this.targetsHours.middle.leads_goal) {
						if (this.targetsHours.top.leads_goal > this.targetsHours.bottom.leads_goal) {
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, 3);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares(4, 4);
							this.$refs.['line-fill-three'].innerHTML = this.getSquares(5, 5);
						}else{
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, from);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares((from + 1), (from + 1));
							this.$refs.['line-fill-three'].innerHTML = this.getSquares((from + 2), 5);
						}
					}else if(this.targetsHours.middle.leads_goal > this.targetsHours.bottom.leads_goal){
						this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, from);
						this.$refs.['line-fill-two'].innerHTML = this.getSquares((from + 1), (4));
						this.$refs.['line-fill-three'].innerHTML = this.getSquares(5, 5);
					}else{
						if (this.workingStrings == 6) {
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(0, 1);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares(2, 3);
							this.$refs.['line-fill-three'].innerHTML = this.getSquares(4, 5);
						}else if(this.workingStrings == 5){
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(1, 2);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares(3, 4);
							this.$refs.['line-fill-three'].innerHTML = this.getSquares(5, 5);
						}else if(this.workingStrings == 4){
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(2, 3);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares(4, 4);
							this.$refs.['line-fill-three'].innerHTML = this.getSquares(5, 5);
						}else if(this.workingStrings <= 3){
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(3, 3);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares(4, 4);
							this.$refs.['line-fill-three'].innerHTML = this.getSquares(5, 5);
						}
					}
					this.fillTop('line-fill-one');
					this.fillMiddle('line-fill-two');
					this.fillBottom('line-fill-three');
				}else if(stringCount == 2){
					var otherEnd;

					if (this.workingStrings == 6) {
						otherEnd = 3;
					}else if(this.workingStrings == 5){
						otherEnd = 3;
					}else if(this.workingStrings == 4){
						otherEnd = 3;
					}else if(this.workingStrings == 3){
						otherEnd = 4;
					}else if(this.workingStrings == 2){
						otherEnd = 4;
					}


					if (top && middle) {
						this.$refs.['line-fill-one'].classList.add('line-t', 'animate');
						this.$refs.['line-fill-two'].classList.add('line-m', 'animate');

						if (this.targetsHours.top.leads_goal > this.targetsHours.middle.leads_goal) {
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, otherEnd);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares((otherEnd + 1), to);
						}else{
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, (otherEnd - 1));
							this.$refs.['line-fill-two'].innerHTML = this.getSquares((otherEnd), to);
						}
						this.fillTop('line-fill-one');
						this.fillMiddle('line-fill-two');
					}else if(top && bottom){
						this.$refs.['line-fill-one'].classList.add('line-t', 'animate');
						this.$refs.['line-fill-two'].classList.add('line-b', 'animate');

						if (this.targetsHours.top.leads_goal > this.targetsHours.bottom.leads_goal) {
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, otherEnd);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares((otherEnd + 1), to);
						}else{
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, (otherEnd - 1));
							this.$refs.['line-fill-two'].innerHTML = this.getSquares((otherEnd), to);
						}
						this.fillTop('line-fill-one');
						this.fillBottom('line-fill-two');
					}else{
						this.$refs.['line-fill-one'].classList.add('line-m');
						this.$refs.['line-fill-two'].classList.add('line-b');

						if (this.targetsHours.middle.leads_goal > this.targetsHours.bottom.leads_goal) {
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, otherEnd);
							this.$refs.['line-fill-two'].innerHTML = this.getSquares((otherEnd + 1), to);
						}else{
							this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, (otherEnd - 1));
							this.$refs.['line-fill-two'].innerHTML = this.getSquares((otherEnd), to);
						}

						this.fillMiddle('line-fill-one');
						this.fillBottom('line-fill-two');
					}
				}else if(stringCount == 1){
					this.$refs.['line-fill-one'].innerHTML = this.getSquares(from, to);

					if (top) {
						this.$refs.['line-fill-one'].classList.add('line-t', 'animate');
						this.fillTop('line-fill-one');
					}else if(middle){
						this.$refs.['line-fill-one'].classList.add('line-m', 'animate');
						this.fillMiddle('line-fill-one');
					}else if(bottom){
						this.$refs.['line-fill-one'].classList.add('line-b', 'animate');
						this.fillBottom('line-fill-one');
					}
				}
			},
			fillTop(ref){
				var lenTop = this.$refs.[ref].children.length;
				var topPercentFill = Number((this.targetsHours.top.leads_generated / this.targetsHours.top.leads_goal) * 100).toFixed(0);
				var topPercentOne = Number(100 / lenTop).toFixed(8);
				var topFill = Number(topPercentFill / topPercentOne).toFixed(0);

				console.log('Top:' + lenTop, topPercentFill, topPercentOne, topFill)

				var offset = lenTop - topFill;

				for (var t = 0; t <= topFill - 1; t++) {
					this.$refs.[ref].children[offset + t].classList.add('fill');
				}
			},
			fillMiddle(ref){
				var lenMiddle = this.$refs.[ref].children.length;
				var middlePercentFill = Number((this.targetsHours.middle.leads_generated / this.targetsHours.middle.leads_goal) * 100).toFixed(0);
				var middlePercentOne = Number(100 / lenMiddle).toFixed(8);
				var middleFill = Number(middlePercentFill / middlePercentOne).toFixed(0);

				console.log('Middle:' + lenMiddle, middlePercentFill, middlePercentOne, middleFill)

				var offset = lenMiddle - middleFill;

				for (var m = 0; m <= middleFill - 1; m++) {
					this.$refs.[ref].children[offset + m].classList.add('fill');
				}
			},
			fillBottom(ref){
				var lenBottom = this.$refs.[ref].children.length;
				var bottomPercentFill = Number((this.targetsHours.bottom.leads_generated / this.targetsHours.bottom.leads_goal) * 100).toFixed(0);
				var bottomPercentOne = Number(100 / lenBottom).toFixed(8);
				var bottomFill = Number(bottomPercentFill / bottomPercentOne).toFixed(0);

				console.log('Bottom:' + lenBottom, bottomPercentFill, bottomPercentOne, bottomFill)

				var offset = lenBottom - bottomFill;

				for (var b = 0; b <= bottomFill - 1; b++) {
					this.$refs.[ref].children[offset + b].classList.add('fill');
				}
			},
			generateLeads(){
				if(this.RightSidebar.state == 'running'){
					for(var item2 in this.campaignData.targets){
						if (this.campaignData.targets[item2].grade == 'Top') {
							this.targetsHours.top.leads_goal += +Number(this.campaignData.targets[item2].leads_goal).toFixed(0);
							this.targetsHours.top.leads_generated += +Number(this.campaignData.targets[item2].leads_generated).toFixed(0);
						}
						if (this.campaignData.targets[item2].grade == 'Middle') {
							this.targetsHours.middle.leads_goal += +Number(this.campaignData.targets[item2].leads_goal).toFixed(0);
							this.targetsHours.middle.leads_generated += +Number(this.campaignData.targets[item2].leads_generated).toFixed(0);
						}
						if (this.campaignData.targets[item2].grade == 'Bottom') {
							this.targetsHours.bottom.leads_goal += +Number(this.campaignData.targets[item2].leads_goal).toFixed(0);
							this.targetsHours.bottom.leads_generated += +Number(this.campaignData.targets[item2].leads_generated).toFixed(0);
						}
					}

					for (var single in this.targetsHours) {
						if (this.targetsHours[single].leads_goal != 0) {
							this.targetsHours[single].percent = Math.floor(Number(this.targetsHours[single].leads_generated / this.targetsHours[single].leads_goal * 100).toFixed(3));
							// this.targetsHours[single].percent = Number(this.targetsHours[single].leads_generated / this.targetsHours[single].leads_goal * 100).toFixed(0);
						}
					}

					var max = 0;
					var next = 0;
					var stringVelocity = Number(this.new_velocity / this.campaignData.targets.length).toFixed(0)
					var percent;
					if (this.campaignData.maximum_campaign_completeness) {
						percent = this.campaignData.maximum_campaign_completeness;
					}else{
						percent = 100;
					}
					percent = percent / 100;
					for(var item in this.campaignData.targets){
						max = Number(+this.campaignData.targets[item].leads_goal * percent).toFixed(0);
						next = Number(+this.campaignData.targets[item].leads_generated + +stringVelocity).toFixed(0);
						var check = max - next;
						if (check > 0) {
							this.campaignData.targets[item].leads_generated = next;
							this.campaignData.targets[item].remaining_leads = Number(this.campaignData.targets[item].leads_goal - next).toFixed(0);
							this.campaignData.targets[item].percent_completion = Math.floor(Number(this.campaignData.targets[item].leads_generated / this.campaignData.targets[item].leads_goal * 100).toFixed(3));
						}else{
							this.campaignData.targets[item].leads_generated = max;
							this.campaignData.targets[item].remaining_leads = this.campaignData.targets[item].leads_goal - max;
							this.campaignData.targets[item].percent_completion = Math.floor(Number(this.campaignData.targets[item].leads_generated / this.campaignData.targets[item].leads_goal * 100).toFixed(3));
						}
					}
					this.createHours();
					this.calcTotal();
					this.$refs.['line-fill-one'].classList.remove('finish');
					this.$refs.['line-fill-two'].classList.remove('finish');
					this.$refs.['line-fill-three'].classList.remove('finish');
				}
				this.checkProgress();
			},
			checkProgress(){
				if(this.targetsHours.top.percent >= 0){
					if (this.targetsHours.top.percent == 100) {
						this.finish.top = true;
						this.$refs.['line-fill-one'].classList.add('finish');
					}
				}else{
					this.finish.top = true;
				}
				if(this.targetsHours.middle.percent >= 0){
					if (this.targetsHours.middle.percent == 100) {
						this.finish.middle = true;
						this.$refs.['line-fill-two'].classList.add('finish');
					}
				}else{
					this.finish.middle = true;
				}
				if(this.targetsHours.bottom.percent >= 0){
					if (this.targetsHours.bottom.percent == 100) {
						this.finish.bottom = true;
						this.$refs.['line-fill-three'].classList.add('finish');
					}
				}else{
					this.finish.bottom = true;
				}

				if (this.finish.top && this.finish.middle && this.finish.bottom) {
					// this.total_main.leads_generated = this.total_main.leads_goal;
					this.campaignFinish = true;
					setTimeout(() => {
						this.$refs.['line-1'].classList.remove('line-t', 'line-m', 'line-b', 'empty');
						this.$refs.['line-2'].classList.remove('line-t', 'line-m', 'line-b');
						this.$refs.['line-3'].classList.remove('line-t', 'line-m', 'line-b');
						this.$refs.['line-fill-one'].classList.remove('line-t', 'line-m', 'line-b', 'animate');
						this.$refs.['line-fill-two'].classList.remove('line-t', 'line-m', 'line-b', 'animate');
						this.$refs.['line-fill-three'].classList.remove('line-t', 'line-m', 'line-b', 'animate');

						this.$refs.['line-1'].innerHTML = '';
						this.$refs.['line-2'].innerHTML = '';
						this.$refs.['line-3'].innerHTML = '';
						this.$refs.['line-fill-one'].innerHTML = '';
						this.$refs.['line-fill-two'].innerHTML = '';
						this.$refs.['line-fill-three'].innerHTML = '';

						this.$refs.['line-1'].classList.add('line-t');
						this.$refs.['line-2'].classList.add('line-t');
						this.$refs.['line-3'].classList.add('line-m');
						this.$refs.['line-fill-one'].classList.add('line-m');
						this.$refs.['line-fill-two'].classList.add('line-b');
						this.$refs.['line-fill-three'].classList.add('line-b');


						this.$refs.['line-1'].innerHTML = this.finishBottom.top[0];
						this.$refs.['line-2'].innerHTML = this.finishBottom.top[1];
						this.$refs.['line-3'].innerHTML = this.finishBottom.middle[0];
						this.$refs.['line-fill-one'].innerHTML = this.finishBottom.middle[1];
						this.$refs.['line-fill-two'].innerHTML = this.finishBottom.bottom[0];
						this.$refs.['line-fill-three'].innerHTML = this.finishBottom.bottom[1];
					}, 500);
				}else{
					this.campaignFinish = false;
				}
			},
			sortFunc: function (obj){
				return obj.sort((a, b) => a.id - b.id );
			},
			showIntegratePopup(){
				this.showIntegrate = true;
			},
			showLeadPopup(){
				this.showGoal = true;
			},
			hidePopups(){
				this.showGoal = false;
				this.showIntegrate = false;
				this.editGoal = false;
			},
			calcOriginal(){
				for (var single in this.campaignData.targets) {
					this.originalGenerated += +this.campaignData.targets[single].leads_generated
				}
			},
			calcTotal(){
				this.total_main = {
					leads_goal: 0,
					percent_completion: 0,
					leads_generated: 0,
					remaining_leads: 0
				}

				for (var single in this.campaignData.targets) {
					this.total_main.leads_goal += +this.campaignData.targets[single].leads_goal;

					this.total_main.leads_generated += +this.campaignData.targets[single].leads_generated

					this.total_main.remaining_leads += +this.campaignData.targets[single].remaining_leads

					if (this.campaignData.targets[single].grade == "Top") {
						this.emptyTop = false;
					}
					if (this.campaignData.targets[single].grade == "Middle") {
						this.emptyMiddle = false;
					}
					if (this.campaignData.targets[single].grade == "Bottom") {
						this.emptyBottom = false;
					}
				}

				this.total_main.percent_completion = Math.floor(this.total_main.leads_generated / this.total_main.leads_goal * 100);

				var sum = Math.round(this.total_main.remaining_leads / this.total_main.leads_goal * 100)
				var percent;

				if (this.campaignData.pacing_type) {
					if (this.campaignData.pacing_type.name == 'even') {
						percent = 30;
					}else{
						percent = 40;
					}

					var newPercent = Math.round(sum * percent / 100);
					this.inProcess = Number(this.total_main.leads_goal * (newPercent / 100)).toFixed(0);
				}

			},
			rainAnimation(){
				if (Object.keys(this.campaignData).length > 0) {
					if (this.campaignData.kind == 'standard' && !this.campaignFinish) {
						this.$refs.['hide-on-load'].classList.add('hide')
						this.$refs.['bottom-part'].classList.add('blick-1')
					}else{
						this.$refs.['hide-on-load'].classList.remove('hide')
						this.$refs.['bottom-part'].classList.remove('blick-1')
						this.$refs.['bottom-part'].classList.remove('blick-2')
					}
					this.$refs.['rain-7'].classList.add('fill-blue')
					var blick = false;
					setInterval(() => {
						if(this.$store.state.Auth.login){
							this.$refs.['bottom-part'].classList.remove('blick-1')
							this.$refs.['bottom-part'].classList.remove('blick-2')
							if (this.campaignData.kind == 'standard' && !this.campaignFinish) {
								if (blick) {
									this.$refs.['bottom-part'].classList.add('blick-1')
								}else{
									this.$refs.['bottom-part'].classList.add('blick-2')
								}
							}
							blick = !blick;
						}
					}, 400)
					var rainRows = ['rain-1', 'ta-t', 'ta-m', 'ta-b', 'rain-2', 'rain-3', 'rain-4', 'rain-5', 'rain-6', 'rain-7'];
					var r1 = 0;
					var pause1 = false;
					var r2 = 0;
					var pause2 = false;
					var r3 = 2;
					var pause3 = false;
					var r4 = 2;
					var pause4 = false;
					var r5 = 5;
					var pause5 = false;
					var r6 = 0;
					var pause6 = false;
					var r7 = 0;
					var pause7 = false;
					setTimeout(() => {
						setInterval(() => {
							if (!pause1 && this.$store.state.Auth.login && this.campaignData.kind != 'copy' && this.campaignData.kind != 'contract' && !this.campaignFinish) {
								if (r1 > 0) {
									if(this.$refs.[rainRows[r1 - 1]].children[12].classList.contains('rain-fill')){
										this.$refs.[rainRows[r1 - 1]].children[12].classList.remove('rain-fill');
									}
								}
								this.$refs.[rainRows[r1]].children[12].classList.add('rain-fill');
								if (r1 == 0) {
									pause1 = true;
									if(this.$refs.[rainRows[rainRows.length - 1]].children[12].classList.contains('rain-fill')){
										this.$refs.[rainRows[rainRows.length - 1]].children[12].classList.remove('rain-fill');
									}
									setTimeout(() => {
										pause1 = false;
									}, 1100)
								}
								if (r1 == rainRows.length - 1) {
									pause1 = true;
									setTimeout(() => {
										if(this.$refs.[rainRows[rainRows.length - 1]].children[12].classList.contains('rain-fill')){
											this.$refs.[rainRows[rainRows.length - 1]].children[12].classList.remove('rain-fill');
										}
									}, 100);
									setTimeout(() => {
										pause1 = false;
									}, 160)
								}
								r1++
								if (r1 == rainRows.length) {
									r1 = 0;
								}
							}
						}, 100)
					}, 30);
					setTimeout(() => {
						setInterval(() => {
							if (!pause2 && this.$store.state.Auth.login && this.campaignData.kind != 'copy' && this.campaignData.kind != 'contract' && !this.campaignFinish) {
								if (r2 > 0) {
									if(this.$refs.[rainRows[r2 - 1]].children[19].classList.contains('rain-fill')){
										this.$refs.[rainRows[r2 - 1]].children[19].classList.remove('rain-fill');
									}
								}
								this.$refs.[rainRows[r2]].children[19].classList.add('rain-fill');
								if (r2 == 0) {
									pause2 = true;
									if(this.$refs.[rainRows[rainRows.length - 1]].children[19].classList.contains('rain-fill')){
										this.$refs.[rainRows[rainRows.length - 1]].children[19].classList.remove('rain-fill');
									}
									setTimeout(() => {
										pause2 = false;
									}, 1280)
								}
								if (r2 == rainRows.length - 4) {
									pause2 = true;
									setTimeout(() => {
										if(this.$refs.[rainRows[rainRows.length - 4]].children[19].classList.contains('rain-fill')){
											this.$refs.[rainRows[rainRows.length - 4]].children[19].classList.remove('rain-fill');
										}
									}, 100);
									setTimeout(() => {
										pause2 = false;
									}, 200)
								}
								r2++
								if (r2 == rainRows.length - 3) {
									r2 = 0;
								}
							}
						}, 100)
					}, 180);
					setTimeout(() => {
						setInterval(() => {
							if (!pause3 && this.$store.state.Auth.login && this.campaignData.kind != 'copy' && this.campaignData.kind != 'contract' && !this.campaignFinish) {
								if (r3 > 2) {
									if(this.$refs.[rainRows[r3 - 1]].children[16].classList.contains('rain-fill')){
										this.$refs.[rainRows[r3 - 1]].children[16].classList.remove('rain-fill');
									}
								}
								this.$refs.[rainRows[r3]].children[16].classList.add('rain-fill');
								if (r3 == 2) {
									pause3 = true;
									if(this.$refs.[rainRows[rainRows.length - 1]].children[16].classList.contains('rain-fill')){
										this.$refs.[rainRows[rainRows.length - 1]].children[16].classList.remove('rain-fill');
									}
									setTimeout(() => {
										pause3 = false;
									}, 1030)
								}
								if (r3 == rainRows.length - 3) {
									pause3 = true;
									setTimeout(() => {
										if(this.$refs.[rainRows[rainRows.length - 3]].children[16].classList.contains('rain-fill')){
											this.$refs.[rainRows[rainRows.length - 3]].children[16].classList.remove('rain-fill');
										}
									}, 100);
									setTimeout(() => {
										pause3 = false;
									}, 1000)
								}
								r3++
								if (r3 == rainRows.length - 2) {
									r3 = 2;
								}
							}
						}, 100)
					}, 1030);
					setTimeout(() => {
						setInterval(() => {
							if (!pause4 && this.$store.state.Auth.login && this.campaignData.kind != 'copy' && this.campaignData.kind != 'contract' && !this.campaignFinish) {
								if (r4 > 2) {
									if(this.$refs.[rainRows[r4 - 1]].children[8].classList.contains('rain-fill')){
										this.$refs.[rainRows[r4 - 1]].children[8].classList.remove('rain-fill');
									}
								}
								this.$refs.[rainRows[r4]].children[8].classList.add('rain-fill');
								if (r4 == 2) {
									pause4 = true;
									if(this.$refs.[rainRows[rainRows.length - 1]].children[8].classList.contains('rain-fill')){
										this.$refs.[rainRows[rainRows.length - 1]].children[8].classList.remove('rain-fill');
									}
									setTimeout(() => {
										pause4 = false;
									}, 1030)
								}
								if (r4 == rainRows.length - 2) {
									pause4 = true;
									setTimeout(() => {
										if(this.$refs.[rainRows[rainRows.length - 2]].children[8].classList.contains('rain-fill')){
											this.$refs.[rainRows[rainRows.length - 2]].children[8].classList.remove('rain-fill');
										}
									}, 100);
									setTimeout(() => {
										pause4 = false;
									}, 230)
								}
								r4++
								if (r4 == rainRows.length) {
									r4 = 2;
								}
							}
						}, 100)
					}, 1180);
					setTimeout(() => {
						setInterval(() => {
							if (!pause5 && this.$store.state.Auth.login && this.campaignData.kind != 'copy' && this.campaignData.kind != 'contract' && !this.campaignFinish) {
								if (r5 > 5) {
									if(this.$refs.[rainRows[r5 - 1]].children[13].classList.contains('rain-fill')){
										this.$refs.[rainRows[r5 - 1]].children[13].classList.remove('rain-fill');
									}
								}
								this.$refs.[rainRows[r5]].children[13].classList.add('rain-fill');
								if (r5 == 5) {
									pause5 = true;
									if(this.$refs.[rainRows[rainRows.length - 1]].children[13].classList.contains('rain-fill')){
										this.$refs.[rainRows[rainRows.length - 1]].children[13].classList.remove('rain-fill');
									}
									setTimeout(() => {
										pause5 = false;
									}, 1090)
								}
								if (r5 == rainRows.length - 1) {
									pause5 = true;
									setTimeout(() => {
										if(this.$refs.[rainRows[rainRows.length - 1]].children[13].classList.contains('rain-fill')){
											this.$refs.[rainRows[rainRows.length - 1]].children[13].classList.remove('rain-fill');
										}
									}, 100);
									setTimeout(() => {
										pause5 = false;
									}, 1000)
								}
								r5++
								if (r5 == rainRows.length) {
									r5 = 5;
								}
							}
						}, 100)
					}, 1120);
					setTimeout(() => {
						// ?
						setInterval(() => {
							if (!pause6 && this.$store.state.Auth.login && this.campaignData.kind != 'copy' && this.campaignData.kind != 'contract' && !this.campaignFinish) {
								if (r6 > 0) {
									if(this.$refs.[rainRows[r6 - 1]].children[8].classList.contains('rain-fill')){
										this.$refs.[rainRows[r6 - 1]].children[8].classList.remove('rain-fill');
									}
								}
								this.$refs.[rainRows[r6]].children[8].classList.add('rain-fill');
								if (r6 == 0) {
									pause6 = true;
									if(this.$refs.[rainRows[rainRows.length - 1]].children[8].classList.contains('rain-fill')){
										this.$refs.[rainRows[rainRows.length - 1]].children[8].classList.remove('rain-fill');
									}
									setTimeout(() => {
										pause6 = false;
									}, 300)
								}
								if (r6 == rainRows.length - 2) {
									pause6 = true;
									setTimeout(() => {
										if(this.$refs.[rainRows[rainRows.length - 2]].children[8].classList.contains('rain-fill')){
											this.$refs.[rainRows[rainRows.length - 2]].children[8].classList.remove('rain-fill');
										}
									}, 100);
									setTimeout(() => {
										pause6 = false;
									}, 2000)
								}
								r6++
								if (r6 == rainRows.length) {
									r6 = 0;
								}
							}
						}, 100)
					}, 2100);
					setTimeout(() => {
						setInterval(() => {
							if (!pause7 && this.$store.state.Auth.login && this.campaignData.kind != 'copy' && this.campaignData.kind != 'contract' && !this.campaignFinish) {
								if (r7 > 0) {
									if(this.$refs.[rainRows[r7 - 1]].children[4].classList.contains('rain-fill')){
										this.$refs.[rainRows[r7 - 1]].children[4].classList.remove('rain-fill');
									}
								}
								this.$refs.[rainRows[r7]].children[4].classList.add('rain-fill');
								if (r7 == 0) {
									pause7 = true;
									if(this.$refs.[rainRows[rainRows.length - 1]].children[4].classList.contains('rain-fill')){
										this.$refs.[rainRows[rainRows.length - 1]].children[4].classList.remove('rain-fill');
									}
									setTimeout(() => {
										pause7 = false;
									}, 300)
								}
								if (r7 == rainRows.length - 5) {
									pause7 = true;
									setTimeout(() => {
										if(this.$refs.[rainRows[rainRows.length - 5]].children[4].classList.contains('rain-fill')){
											this.$refs.[rainRows[rainRows.length - 5]].children[4].classList.remove('rain-fill');
										}
									}, 100);
									setTimeout(() => {
										pause7 = false;
									}, 1000)
								}
								r7++
								if (r7 == rainRows.length) {
									r7 = 0;
								}
							}
						}, 100)
					}, 3100);
				}
			},
			contactManager(){
				var contactM = !this.RightSidebar.contactM;
				this.updateRS(['triggerContact', true]);
				this.updateRS(['contactM', contactM]);
				setTimeout(() => {
					this.updateRS(['triggerContact', false]);
				}, 250)
			},
			setDefaultHours(){
				this.workingLines = 3;
				this.baseFill = 0;
				setTimeout(() => {
					this.$refs.['line-1'].classList.remove('line-t', 'line-m', 'line-b', 'empty');
					this.$refs.['line-2'].classList.remove('line-t', 'line-m', 'line-b');
					this.$refs.['line-3'].classList.remove('line-t', 'line-m', 'line-b');
					this.$refs.['line-fill-one'].classList.remove('line-t', 'line-m', 'line-b', 'animate');
					this.$refs.['line-fill-two'].classList.remove('line-t', 'line-m', 'line-b', 'animate');
					this.$refs.['line-fill-three'].classList.remove('line-t', 'line-m', 'line-b', 'animate');

					this.$refs.['line-1'].innerHTML = '';
					this.$refs.['line-2'].innerHTML = '';
					this.$refs.['line-3'].innerHTML = '';
					this.$refs.['line-fill-one'].innerHTML = '';
					this.$refs.['line-fill-two'].innerHTML = '';
					this.$refs.['line-fill-three'].innerHTML = '';

					this.$refs.['line-1'].classList.add('line-t');
					this.$refs.['line-2'].classList.add('line-t');
					this.$refs.['line-3'].classList.add('line-m');
					this.$refs.['line-fill-one'].classList.add('line-m');
					this.$refs.['line-fill-two'].classList.add('line-b');
					this.$refs.['line-fill-three'].classList.add('line-b');


					this.$refs.['line-1'].innerHTML = this.defaultBottom.top[0];
					this.$refs.['line-2'].innerHTML = this.defaultBottom.top[1];
					this.$refs.['line-3'].innerHTML = this.defaultBottom.middle[0];
					this.$refs.['line-fill-one'].innerHTML = this.defaultBottom.middle[1];
					this.$refs.['line-fill-two'].innerHTML = this.defaultBottom.bottom[0];
					this.$refs.['line-fill-three'].innerHTML = this.defaultBottom.bottom[1];
				}, 500);
			},
			selectUnselect(){
				var trigger = !this.RightSidebar.trigger;
				this.updateRS(['trigger', trigger]);
				var status = true;
				for(var section in this.RightSidebar.sections){
					if (this.RightSidebar.sections[section].slug == "ABM" || this.RightSidebar.sections[section].slug == "SuppressionList" || this.RightSidebar.sections[section].slug == "JobTitle" || this.RightSidebar.sections[section].slug == "Industries" || this.RightSidebar.sections[section].slug == "Geo" || this.RightSidebar.sections[section].slug == "Revenue" || this.RightSidebar.sections[section].slug == "CompanySize") {
						if (this.RightSidebar.sections[section].enabled != status) {
							this.setStatus(status);
							return false;
						}
					}
				}
				this.setStatus(false);
			},
			setStatus(status){
				for(var section2 in this.RightSidebar.sections){
					if (this.RightSidebar.sections[section2].slug == "ABM" || this.RightSidebar.sections[section2].slug == "SuppressionList" || this.RightSidebar.sections[section2].slug == "JobTitle" || this.RightSidebar.sections[section2].slug == "Industries" || this.RightSidebar.sections[section2].slug == "Geo" || this.RightSidebar.sections[section2].slug == "Revenue" || this.RightSidebar.sections[section2].slug == "CompanySize") {
							this.RightSidebar.sections[section2].enabled = status;
					}
				}
				this.updateRS(['sections', this.RightSidebar.sections]);
				this.changeTA();
			}
			// runHour(){
			// 	setInterval(function(){
					
			// 	}, fullSpeed);
			// }
		}
	}
</script>